import { render, staticRenderFns } from "./FileInputField.vue?vue&type=template&id=021d1dda&scoped=true&"
import script from "./FileInputField.vue?vue&type=script&lang=js&"
export * from "./FileInputField.vue?vue&type=script&lang=js&"
import style0 from "./FileInputField.vue?vue&type=style&index=0&id=021d1dda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021d1dda",
  null
  
)

export default component.exports